var map = {
	"./10_nuts.png": 2450,
	"./1drink_12beer.png": 2451,
	"./1serving_8ounces.png": 2452,
	"./1serving_8ounces2.png": 2453,
	"./1serving_8ounces3.png": 2454,
	"./1serving_8ounces4.png": 2455,
	"./1serving_8ounces5.png": 2456,
	"./8ounces_1glass.png": 2457,
	"./can_1.png": 2458,
	"./can_2.png": 2459,
	"./can_3.png": 2460,
	"./cup.png": 2461,
	"./dried_serving_1/4cup.png": 2462,
	"./dried_serving_1:4cup.png": 2463,
	"./fresh_serving_1cup.png": 2464,
	"./glass_1.png": 2465,
	"./glass_2.png": 2466,
	"./golfball.png": 2467,
	"./halfthumb.png": 2468,
	"./hand_1.png": 2469,
	"./hand_2.png": 2470,
	"./hand_3.png": 2471,
	"./hand_4.png": 2472,
	"./hand_5.png": 2473,
	"./how.png": 850,
	"./serving_1/2cup.png": 2474,
	"./serving_1:2cup.png": 2475,
	"./serving_1tbsp.png": 2476,
	"./serving_3/4ounces.png": 2477,
	"./serving_3:4ounces.png": 2478,
	"./thumbx2.png": 2479,
	"./usda.png": 2480,
	"./vegetables_1cup.png": 2481,
	"./what.png": 848,
	"./wholethumb.png": 2482,
	"./why.png": 849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2449;